import { dataAppStore } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAppStore = /*#__PURE__*/createIcon(dataAppStore)
export default IconAppStore
